import 'bootstrap/dist/js/bootstrap.min.js';

import 'webticker/jquery.webticker';

import 'sticky-sidebar';


// import './components/map';
import './components/menu';
import './components/cookies';
import './components/scrollUp';

import './components/slider';
// import './components/slider-4';
// import './components/slider-multi-images';
import './components/sidebar';

$('.rso_ticker').webTicker({
    duplicate: true,
    startEmpty: false,
    hoverpause: true
});

$('#slider-multi-images').each(function () {
    var $slideshow = $(this);
    $slideshow.skidder({
        slideClass: '.slide',
        animationType: 'animate',
        scaleSlides: true,
        maxWidth: 1300,
        maxHeight: 500,
        paging: true,
        autoPaging: true,
        pagingWrapper: ".skidder-pager",
        pagingElement: ".skidder-pager-dot",
        swiping: true,
        leftaligned: false,
        cycle: true,
        jumpback: false,
        speed: 400,
        autoplay: true,
        autoplayResume: true,
        interval: 4000,
        transition: "slide",
        afterSliding: function () { },
        afterInit: function () { }
    });
});

$('#header-topbar-searchform-button').on('click', function () {
    $('#searchform-field-wrapper').toggleClass('open');
});
$('#header-topbar-searchform-button-close').on('click', function () {
    $('#searchform-field-wrapper').toggleClass('open');
});

$('.accordion-menu .dropdown-toggle').on('click', function (event) {
    if (!$(this).parent().hasClass('menu-item-active')) {
        event.preventDefault();
        $(this).parent().addClass('menu-item-active');
    }
});



// $(window).on("load", function () {
//     setTimeout(function () {
//         $('.loader').fadeOut();
//     }, 500);
// });

// jQuery(document).ready(function ($) {
//     $('#news-slider').sliderPro({
//         width: 1213,
//         height: 540,
//         orientation: 'vertical',
//         loop: false,
//         arrows: true,
//         buttons: false,
//         thumbnailsPosition: 'right',
//         thumbnailPointer: true,
//         thumbnailWidth: 420,
//         thumbnailHeight: 135,
//         breakpoints: {
//             1280: {
//                 thumbnailsPosition: 'bottom',
//                 thumbnailWidth: 300,
//                 thumbnailHeight: 135,
//                 width: 1280,
//                 height: 500
//             },
//             990: {
//                 thumbnailsPosition: 'bottom',
//                 thumbnailWidth: 60,
//                 thumbnailHeight: 80,
//                 width: 990,
//                 height: 500
//             },
//             782: {
//                 thumbnailsPosition: 'bottom',
//                 thumbnailWidth: 60,
//                 thumbnailHeight: 80,
//                 width: 782,
//                 height: 500
//             }
//         }
//     });


//     $('#news-slider').addClass('active');
// });


var windowWidth = $(window).width();

// async function detectAdBlock() {
//     let adBlockEnabled = false
//     const googleAdUrl = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
//     try {
//         await fetch(new Request(googleAdUrl)).catch(_ => adBlockEnabled = true)
//     } catch (e) {
//         adBlockEnabled = true
//     } finally {
//         var request = $.ajax({
//             url: options.ajax_url,
//             type: "POST", 
//             data: {
//                 'action': 'adblock_check',
//                 'is_enabled': adBlockEnabled
//             },
//             dataType: "json"
//         });
//     }
// }
// detectAdBlock()



$(document).ready(function () {

    // if($('.sidebar-inner-fixed').length) {
    //     var sidebar = new StickySidebar('.sidebar-inner-fixed', {
    //         topSpacing: 75,
    //         bottomSpacing: 20
    //     });
    // }

    $('.contact-email').each(function () {
        var email = $(this);
        email.text(email.data('contact-1') + '@' + email.data('contact-2'));
        email.attr('href', 'mailto: ' + email.data('contact-1') + '@' + email.data('contact-2'));
    });

    adjustElementHeight('#homepage-shortcuts .shortcuts-box-inner');

    $('#fb-sidebox-button').on('click', function () {
        $(this).parent().toggleClass('active');
    });


    if ($('#events-calendar').length > 0) {
        var calendarCategory = false;

        if ($('#events-calendar').data('category')) {
            calendarCategory = $('#events-calendar').data('category');
        }

        $("#events-calendar").eventCalendar({
            eventsjson: options.ajax_url + '?action=get_events&category=' + calendarCategory,
            locales: {
                locale: "pl",
                monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Pażdziernik", "Listopad", "Grudzień"],
                dayNames: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
                dayNamesShort: ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Nie'],
                txt_noEvents: "Brak wydarzeń",
                txt_SpecificEvents_prev: "",
                txt_SpecificEvents_after: "wydarzenia:",
                txt_next: ">",
                txt_prev: "<",
                txt_NextEvents: "Nadchodzące wydarzenia:",
                txt_GoToEventUrl: "Czytaj więcej",
                txt_loading: 'Ładowanie...',

            }
        });
    }


    // var bannersSlider = $('.banners-slider-carousel');

    // if (bannersSlider.length > 0) {
    //     bannersSlider.owlCarousel({
    //         loop: true,
    //         margin: 10,
    //         dots: false,
    //         nav: false,
    //         autoplay: true,
    //         smartSpeed: 500,
    //         autoplayTimeout: 3000,
    //         autoplayHoverPause: true,
    //         responsiveClass: true,
    //         responsive: {
    //             0: {
    //                 items: 2
    //             },
    //             600: {
    //                 items: 3
    //             },
    //             1000: {
    //                 items: 5
    //             }
    //         }
    //     });
    // }

    $('#sidebar-menu .menu-item-has-children > a').click(function (event) {
        event.preventDefault();

        $(this).parent().toggleClass('active');
    });

    if ($('#newsletterModal').length > 0) {
        $('#newsletterModal').modal('show');
    }
});

$(window).scroll(function () {
    var header = $('header#header');
    var nav = $('.site-menu-content');

    if (windowWidth > 768) {
        if ($(window).scrollTop() > header.height() * 2) {
            header.addClass('fixed-menu');
            nav.addClass('fixed-menu');
        } else {
            header.removeClass('fixed-menu');
            nav.removeClass('fixed-menu');
        }
    }
});

function adjustElementHeight(elementName) {
    var headingHeight = 0;
    $(elementName).each(function () {
        if (headingHeight < $(this).height()) {
            headingHeight = $(this).height();
        }
    })
    $(elementName).height(headingHeight);
}